import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../../environments/environment';

import { CulqiTarjeta } from '../clases/culqi-tarjeta';
import { Tarjeta } from '../clases/tarjeta';

@Injectable({
  providedIn: 'root'
})
export class MetodoPagoService {
  private headers = new HttpHeaders();
  constructor(private _http: HttpClient,

    ) { }

  requestListarTarjetas(idCliente: number) {
    const url = environment.URL_BASE + "tarjetaAuthorization/all?id=" + idCliente;
    return this._http.get(url);
  }

  requestCrearToken(infoTarjeta: CulqiTarjeta) {
    const url = environment.URL_PAYU + "culqi/httpCrearToken";
    return this._http.post(url, infoTarjeta);
  }
  requestGenerarSession(idCliente : number) {
    const url = environment.URL_VISANET + "visanet/HttpGenerarSession?idCliente=" + idCliente;
    return this._http.get(url);
  }
  requestGenerarTokenCard(data : any) {
    const url = environment.URL_VISANET + "visanet/HttpGenerartokenCard" +  "?requestTokenCard=" + data + "&modoReserva=4";
    const headers = this.headers.append('Content-Type', 'application/json')
    return this._http.get(url,{ headers: headers});
  }

  requestRegistrarTarjeta(tarjeta: Tarjeta) {
    const url = environment.URL_PAYU +  "Operation/RegistrarTarjeta";
    return this._http.post(url, tarjeta)
  }
  requestRegistrarTarjetaVisanet(tarjeta: Tarjeta) {
    const url = environment.URL_VISANET +  "Operation/RegistrarTarjeta";
    return this._http.post(url, tarjeta)
  }
  requestEliminarTarjetaVisanet(data: any) {
    const url = environment.URL_VISANET + 'Operation/EliminarTarjeta';
    return this._http.post(url, data);
  }
  requestEliminarTarjeta(data: any) {
    const url = environment.URL_PAYU + 'Operation/EliminarTarjeta';
    return this._http.post(url, data);
  }
  

  requestTarjetaDefault(idToken: any){
    const url = environment.URL_BASE +'tarjetaAuthorization/defaultCard';
    return this._http.post(url,idToken)
    }

  getTipoComprobante(){
    const url =environment.URL_BASE+"tipoPago/getTipoComprobante"
    return this._http.get(url)
  }
}
